import React from 'react';

function toneFor(pct) {
  if (pct < 40) return 'danger';
  if (pct < 70) return 'warn';
  return 'success';
}

/**
 * Barra continua + porcentaje. Usada en la tabla del dashboard para la columna
 * "Vulnerabilidad" de cada fila (a diferencia de HealthBar, que es el resumen global).
 */
function ScoreBar({ value = 0, label, className = '' }) {
  const clamped = Math.max(0, Math.min(100, value));
  const tone = toneFor(clamped);

  return (
    <div className={`sgc-score-bar ${className}`}>
      <div className="sgc-score-bar__track">
        <div
          className={`sgc-score-bar__fill sgc-score-bar__fill--${tone}`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <span className="sgc-score-bar__label">{label ?? `${clamped}%`}</span>
    </div>
  );
}

export default ScoreBar;
